"use client";

import { basketService } from "@/services/basket/basketService";
import { ShoppingBasket } from "lucide-react";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const NavbarBasket = () => {
  const [basketCount, setBasketCount] = useState(0);

  useEffect(() => {
    // Abone ol, count değişince state'i güncelle
    const unsubscribe = basketService.subscribe((basketItemCount) => {
      setBasketCount(basketItemCount ?? 0);
    });

    return unsubscribe;
  }, []);

  return (
    <NavLink
      to="/basket"
      className={({ isActive }) =>
        `relative p-2 rounded-md transition-colors duration-200 ${
          isActive
            ? "text-primary-600 dark:text-primary-400"
            : "text-gray-600 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400"
        }`
      }
    >
      <ShoppingBasket className="h-5 w-5" />
      {basketCount > 0 && (
        <span className="absolute top-2 left-3 bg-primary text-white rounded-full min-w-[18px] h-[18px] flex items-center justify-center text-[11px] font-bold shadow-md z-10 px-[5px]">
          {basketCount}
        </span>
      )}
      <span className="sr-only">
        Shopping basket {basketCount > 0 ? `(${basketCount} items)` : "(empty)"}
      </span>
    </NavLink>
  );
};

export default NavbarBasket;
